import { useQuery } from "react-query";
import axios from "axios";
import {useSelector } from "react-redux";
import {apiUrlSelector} from "../redux/selectors";

export const useStops = () => {
    const apiUrl = useSelector(apiUrlSelector);
    return useQuery(["stops", apiUrl], () =>
        axios.get(`${apiUrl}stops`).then(res => res.data.data),
        {
            refetchOnWindowFocus: false,
            placeholderData: []
        }
    );
};

export default useStops;